import * as React from "react";
const SvgMImage = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 528" style={{
    fill: "none"
  }} /><path d="M10 8v8l5-4zm9-5H5a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V5a2.006 2.006 0 0 0-2-2m0 16H5V5h14z" data-name="Trazado 529" /></svg>;
export { SvgMImage as ReactComponent };